export default "__VITE_ASSET__CEAWkR6u__"